/* 获取账号未读消息数
demo:
import IMUnreadMsgNumMixin from 'src/common/components/Bussiness/IM/IMUnreadMsgNumMixin.js';

mixins: [IMUnreadMsgNumMixin],
*/
import { _get } from '@/common/request';
import { StaticPaths } from '@/common/request/utils';
export default {
  props: {
    // 是否立即获取消息
    immediate: {
      type: Boolean,
      default: true
    },
    // 轮询时间间隔，单位 ms
    duration: {
      type: Number,
      default: 5000
    }
  },

  data() {
    return {
      marqueeTitle: '  您收到新消息了!　|　',
      titleInit: '',
      timer: null, // 获取数据的定时器
      unreadMsgNum: 0, // 该账号未读消息
      contactCount: 0, // 该账号会话数量
      remindTitleTimer: null, // 消息提醒标题的定时器
    };
  },


  watch: {
    '$route': {
      handler() {
        this.titleInit = document.title; // 记录下当前标题
      },
      immediate: true,
      deep: true
    },
  },

  mounted() {
    this.setTimer();
  },

  beforeDestroy() {
    this.clearTimer();
    this.clearRemindTitleTimer();
  },

  methods: {
    // 设置计时器
    setTimer() {
      this.immediate && this.getUnreadMsgNum();
      // 每秒获取账号未读消息
      const fn = () => {
        this.timer = setTimeout(() => {
          this.getUnreadMsgNum();
          fn();
        }, this.duration);
      };
      fn();
    },
    initTitle() {
      // 获取标题
      // const title = /收到新消息/.test(document.title) ? document.title : (this.marqueeTitle + this.titleInit);
      const title = document.title;
      // 分割字符串--->字符数组
      const arr = title.split('');
      // 删除第一个元素并返回该元素
      const e = arr.shift();
      // 把一个对象添加到数组末尾
      arr.push(e);
      // 把数组转换成字符串
      const marquee = arr.join('');
      // 返回给浏览器
      document.title = marquee;
    },
    /**
     * @description 设置提醒标题的定时器
     */
    setRemindTitleTimer() {
      clearInterval(this.remindTitleTimer);
      this.remindTitleTimer = setInterval(this.initTitle, 300);
    },

    /**
     * @description 清楚提醒标题的定时器
     */
    clearRemindTitleTimer() {
      if (this.remindTitleTimer) {
        clearInterval(this.remindTitleTimer);
        this.remindTitleTimer = null;
        document.title = this.titleInit;
      }
    },

    // 清除计时器
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    // 调用接口获取未读消息
    getUnreadMsgNum() {
      if (process.env.NODE_ENV !== 'development' && this.$route.path !== '/' && StaticPaths.indexOf(this.$route.path) < 0) {
        // https://yapi.lanhanba.com/project/319/interface/api/53906
        _get('/im/getUnreadMsgNum', null, { proxyApi: '/pms', isMock: false, mockId: 319 }).then((response) => {
          // console.log('getUnreadMsgNum', response);
          this.unreadMsgNum = response?.unreadMsgNum || 0;
          this.contactCount = response?.contactCount || 0;

          if (this.unreadMsgNum && this.$route.path !== '/lhb-micro-pms/business') {
            this.setRemindTitleTimer();
            document.title = this.marqueeTitle + this.titleInit + '　';
          } else {
            this.clearRemindTitleTimer();
            document.title = this.titleInit;
          }
        });
      }
    },

  }


};
